"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Carousel", {
    enumerable: true,
    get: function() {
        return Carousel;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _components = require("@cmpsr/components");
var _purereactcarousel = require("pure-react-carousel");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var Carousel = function(_param) {
    var children = _param.children, _param_visibleSlides = _param.visibleSlides, visibleSlides = _param_visibleSlides === void 0 ? 1 : _param_visibleSlides, props = _object_without_properties(_param, [
        "children",
        "visibleSlides"
    ]);
    var _Children_map = _sliced_to_array(_react.Children.map(children, function(child) {
        if ((0, _react.isValidElement)(child) && child.type === Carousel.Slider) {
            return _react.Children.count(child.props.children);
        }
    }), 1), totalSlides = _Children_map[0];
    if (!totalSlides) return;
    return _react.default.createElement(_components.Box, _object_spread({
        as: _purereactcarousel.CarouselProvider,
        position: "relative",
        totalSlides: totalSlides,
        visibleSlides: visibleSlides,
        dragStep: visibleSlides,
        step: visibleSlides
    }, props), children);
};
var CarouselButtonBack = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return (0, _react.isValidElement)(children) && (0, _react.cloneElement)(children, _object_spread({
        as: _purereactcarousel.ButtonBack,
        "aria-label": "back"
    }, props));
};
var CarouselButtonNext = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return (0, _react.isValidElement)(children) && (0, _react.cloneElement)(children, _object_spread({
        as: _purereactcarousel.ButtonNext,
        "aria-label": "next"
    }, props));
};
var CarouselDot = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        as: _purereactcarousel.Dot,
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        background: "primary-disabled",
        _disabled: {
            background: "primary-default"
        }
    }, props));
};
var CarouselDotGroup = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        as: _purereactcarousel.DotGroup,
        gap: "12px",
        disableActiveDots: true
    }, props));
};
var CarouselNavigationContainer = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        mt: "spacer-16"
    }, props));
};
var CarouselSlide = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        _last: {
            marginRight: "0px"
        },
        marginRight: "24px",
        as: _purereactcarousel.Slide
    }, props));
};
Carousel.Slider = _purereactcarousel.Slider;
Carousel.Slide = CarouselSlide;
Carousel.ButtonBack = CarouselButtonBack;
Carousel.ButtonNext = CarouselButtonNext;
Carousel.DotGroup = CarouselDotGroup;
Carousel.Dot = CarouselDot;
Carousel.NavigationContainer = CarouselNavigationContainer;
